import { Datavalue } from './Datavalue';
export class InputParameter {
  compname: string;
  length: string;
  dbfield: string;
  width: string;
  height: string;
  column_no: string;
  cols_spans: string;
  title: string;
  mandatory: boolean;
  on_change: string;
  color: string;
  format: string;
  list: string;
  order: string;
  ref_combo: string;
  cmp_group: string;
  default_val: string;
  hint: string;
  style: string;
  value: any;
  datavalues: Datavalue[];
  combo_search_query: string;
  combo_value_field: string;
  combo_disp_field: string;
  readonly: boolean = true;
  component: any;
  displaytext: string;
  errormessage: string;
  isvalid:boolean=true;
  unique:boolean= false;
  unique_query:string= "";
  allowedit:boolean;
}
